import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './Project.css';
import { useLocation, Link, useParams } from "react-router-dom";
import Components from './components';
import Button from './Button';
import { portfolioData } from './Constants';
import { protectedPortfolioData } from './protectedProjects';

const SITE_URL = "https://www.jeffreyserio.com";

const allProjects = [...portfolioData, ...protectedPortfolioData];

const Project = (props) => {
  const { projectPath } = useParams();
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  // Try to get dynamic state, then check location state, finally search portfolioData by path
  let state = location.state;
  let projectData = null;

  if (!state && projectPath) {
    const foundProject = allProjects.find(p => p.path === projectPath);
    if (foundProject) {
      state = foundProject.project;
      projectData = foundProject;
    }
  }

  // Also find projectData if state came from location but we have a path
  if (!projectData && projectPath) {
    projectData = allProjects.find(p => p.path === projectPath);
  }

  // Build OG meta values from the first project item
  const currentProject = state ? state[0] : null;
  const ogTitle = currentProject ? currentProject.projecttitle : "Jeffrey Serio";
  const ogDescription = currentProject ? currentProject.largetag : "Portfolio";
  const ogImage = currentProject
    ? (currentProject.heroimageurl?.startsWith('http')
      ? currentProject.heroimageurl
      : SITE_URL + currentProject.heroimageurl)
    : "";
  const ogUrl = projectPath
    ? `${SITE_URL}/project/${projectPath}`
    : SITE_URL;

  const handleShare = () => {
    const shareData = {
      title: ogTitle,
      text: ogDescription,
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch(() => {});
    } else {
      navigator.clipboard.writeText(window.location.href).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  return (
    <>
      {currentProject && (
        <Helmet>
          <title>{ogTitle} — Jeffrey Serio</title>
          <meta property="og:title" content={ogTitle} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:url" content={ogUrl} />
          <meta property="og:type" content="website" />
          <meta name="description" content={ogDescription} />
        </Helmet>
      )}

      {state && (

        <div>

          {state.map((state, index) => {


            return (

              <div key={index}>



                <div className="project-description-container">
                  <div className="project-title">{state.projecttitle}</div>
                  {state.client && (
                    <div className="project-client">{"Clients & Partners: " + state.client}</div>
                  )}
                </div>
                <div className={`feature-fill ${state.herovideourl ? 'has-video' : ''}`}>
                  {state.herovideourl ? (
                    <div style={{ padding: '56.25% 0 0 0', position: 'relative', width: '100%' }}>
                      <iframe
                        src={state.herovideourl}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                        allowFullScreen
                        referrerPolicy="strict-origin-when-cross-origin"
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title={state.projecttitle}
                      />
                    </div>
                  ) : (
                    <img src={state.heroimageurl} alt={state.projecttitle} />
                  )}
                </div>
                <div className="project-description-container">
                  <div className="project-description">{state.largetag}</div>
                  <div className="project-content">
                    {state.content.body.map(block => Components(block))}
                    <div className="project-bottom-actions">
                      <Button to="/work" text="Back To Work" className="secondary" />
                      <Button onClick={handleShare} text={copied ? 'Copied ✓' : 'Share'} />
                    </div>
                  </div>
                </div>



              </div>
            );
          })}


        </div>

      )}


    </>
  );
};

export default Project;